module.exports = __webpack_public_path__ + "static/yelp-1af3fdb8daa0402f49d2461fb009f8b8.png";